angular
	.module('underscore', [])
	.factory('_', function() {
		return window._;
	});


//////////////////
// WEBPACK FOOTER
// ./~/angular-underscore/index.js
// module id = 371
// module chunks = 0